import requestMethods from '@/helpers/request/requestMethods';
import {
    getMyMessagesApiConfig,
    getUnreadMessagesCountApiConfig,
    setMessagesAsReadApiConfig
} from '@/constants/ApiUrls';

function getMyMessages({ next }) {
    return requestMethods.get({
        routeConfig: {
            ...getMyMessagesApiConfig, // todo: clean this after backend fix
            url: (next && next.replace('http', 'https')) || getMyMessagesApiConfig.url
        }
    });
}

function getUnreadMessagesCount() {
    return requestMethods.get({
        routeConfig: getUnreadMessagesCountApiConfig
    });
}

function setMessagesAsRead({ readMessagesIds }) {
    return requestMethods.post({
        routeConfig: setMessagesAsReadApiConfig,
        data: readMessagesIds.map((id) => id.toString())
    });
}

export { getMyMessages, setMessagesAsRead, getUnreadMessagesCount };
